import { render, staticRenderFns } from "./DataIndex.vue?vue&type=template&id=920fcfc4&scoped=true"
import script from "./DataIndex.vue?vue&type=script&lang=js"
export * from "./DataIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920fcfc4",
  null
  
)

export default component.exports